import axios from 'axios';

const API_BASE = '/api/todo';

const authHeader = (token) => ({ Authorization: `Bearer ${token}` });

// 📋 목록 조회
// dateFilter: today / upcoming / overdue / no_due / selected_date
// status: incomplete / complete / all
export const getTodos = async ({ dateFilter = 'no_due', targetDate, status = 'incomplete', page = 1, limit = 50 }, token) => {
  const res = await axios.get(API_BASE, {
    params: { dateFilter, targetDate, status, page, limit },
    headers: authHeader(token),
  });
  return res.data; // { todos: [], total: number }
};

// 📋 단건 조회
export const getTodoById = async (todoId, token) => {
  const res = await axios.get(`${API_BASE}/${todoId}`, {
    headers: authHeader(token),
  });
  return res.data;
};

// 📋 원본별 단건 조회
export const getTodoByRef = async ({ ref_type, ref_id }, token) => {
  const res = await axios.get(`${API_BASE}/by-ref`, {
    params: { ref_type, ref_id },
    headers: authHeader(token),
  });
  return res.data;
};

// 📋 등록
// payload: { ref_type, ref_table, ref_id, title, memo, priority, due_type, due_date }
export const createTodo = async (payload, token) => {
  const res = await axios.post(API_BASE, payload, {
    headers: { ...authHeader(token), 'Content-Type': 'application/json' },
  });
  return res.data;
};

// 📋 수정 (제목/메모/기한/중요도)
// payload: { title, memo, priority, due_type, due_date }
export const updateTodo = async (todoId, payload, token) => {
  const res = await axios.put(`${API_BASE}/${todoId}`, payload, {
    headers: { ...authHeader(token), 'Content-Type': 'application/json' },
  });
  return res.data;
};

// 📋 상태 변경 (완료/미완료)
// status: 'incomplete' | 'complete'
export const updateTodoStatus = async (todoId, status, token) => {
  const res = await axios.patch(`${API_BASE}/${todoId}/status`, { status }, {
    headers: { ...authHeader(token), 'Content-Type': 'application/json' },
  });
  return res.data;
};

// 📋 삭제
export const deleteTodo = async (todoId, token) => {
  const res = await axios.delete(`${API_BASE}/${todoId}`, {
    headers: authHeader(token),
  });
  return res.data;
};

// 📋 등록구분별 source 매핑 헬퍼
// 각 등록구분 화면에서 등록 레이어에 넘길 source 객체 생성
export const makeTodoSource = (refType, refTable, refId, sourceTitle) => ({
  ref_type:  refType,
  ref_table: refTable,
  ref_id:    refId,
  title:     sourceTitle,
});

// 등록구분 상수
export const TODO_REF_TYPE = {
  BOARD:    'board',
  APPROVAL: 'approval',
  RESOURCE: 'resource',
  SCHEDULE: 'schedule',
  PMS_CHECKLIST: 'pms_checklist',
  PMS_COMMENT:   'pms_comment',
  PMS_FEED:      'pms_feed',
};

export const TODO_REF_TABLE = {
  BOARD:    'tdx_board',
  APPROVAL: 'tdx_aprv_doc',
  RESOURCE: 'tdx_res_reservation',
  SCHEDULE: 'tdx_schedule',
};
